import * as S from './Certificates.styled';

export default function Certificates() {
    return (
        <S.Container>
            <S.Title>
                ALL IMMIGRATION PROFESSIONALS ARE QUALIFIED BY ALIRO{' '}
                <span style={{ whiteSpace: 'nowrap' }}>& LICENSED BY:</span>
            </S.Title>
            <S.TitleMobile>
                ALL IMMIGRATION <br />
                PROFESSIONALS ARE QUALIFIED
                <br />
                BY ALIRO & LICENSED BY:
            </S.TitleMobile>
            <S.Certificates>
                <S.Certificate>
                    <img src="/CCIC grey.png" alt="CCIC" />
                </S.Certificate>
                <S.Certificate>
                    <img src="/MARA grey.png" alt="MARA" />
                </S.Certificate>
            </S.Certificates>
        </S.Container>
    );
}
